import { Component, h, Listen } from '@stencil/core';
import { Element, Event, EventEmitter, Prop } from '@stencil/core/internal';

@Component({
  tag: 'pnk-navigation',
  styleUrl: 'pnk-navigation.css',
  shadow: false,
})
export class PnkNavigation {
  @Element() host!: HTMLElement;

  @Prop({ mutable: true }) group: string = '';

  @Prop({ mutable: true }) section: string = '';

  @Prop() icon: string = '';

  @Prop({ mutable: true, reflect: true }) selected: boolean = true;

  @Event() navClick!: EventEmitter<string>;

  handleNavigation() {
    this.navClick.emit(this.section);
  }

  // Handle the selection of the component
  handleClick() {
    this.selected = !this.selected;
  }

  // Handle the selection of the items inside the componenet

  @Listen('click', { target: 'window' })
  handleWindowClick(event: MouseEvent) {
    const target = event.target as Element;
    if (this.selected && !this.host.contains(target) && !target.hasAttribute('data-nav-item')) {
      this.selected = false;
    }
  }

  ngOnDestroy() {
    window.removeEventListener('click', this.handleWindowClick);
  }

  render() {
    return (
      <div class={`pnk-bg-disabled-base  pnk-ml-3 pnk-px-5 pnk-py-3 pnk-rounded-xl pnk-flex pnk-flex-col pnk-w-[265px] pnk-h-auto${!this.selected ? 'pnk-h-[30px]' : ''}`}>
        <div class="pnk-flex pnk-flex-row pnk-justify-between pnk-items-center ">
          <div class="pnk-flex pnk-flex-row pnk-gap-2 pnk-items-center" onClick={() => this.handleClick()}>
            <div class={'pnk-cursor-pointer '}>
              <slot name="icon"></slot>
            </div>

            <div class={'pnk-cursor-pointer '}>
              <h1 class="pnk-text-disabled-text pnk-text-sm pnk-font-bold pnk-cursor-pointer ">{this.group}</h1>
            </div>
          </div>
          <div class="pnk-relative">
            <slot name="group"></slot>
          </div>
        </div>
        <div class={{ 'pnk-hidden': !this.selected, 'pnk-cursor-pointer': true }} onClick={() => this.handleNavigation()}>
          <slot name="items" />
        </div>
      </div>
    );
  }
}
